import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62d6af24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-red-pack small-container" }
const _hoisted_2 = { class: "create-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "create-text" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Transaction Failed"),
  /*#__PURE__*/_createElementVNode("p", null, " Your transaction failed to be written to the blockchain. Please try again. ")
], -1))
const _hoisted_4 = { class: "create-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Try Again", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_greeting_card = _resolveComponent("greeting-card")!
  const _component_personality_button = _resolveComponent("personality-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_greeting_card, {
        img: require('@/assets/images/missionwagmiIcon/web_fail.jpg'),
        isLinear: false
      }, null, 8, ["img"])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_personality_button, {
        type: "form",
        onClick: _ctx.retryHandler
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}